import { render, staticRenderFns } from "./TrapList.vue?vue&type=template&id=48d42c82&scoped=true&"
import script from "./TrapList.vue?vue&type=script&lang=js&"
export * from "./TrapList.vue?vue&type=script&lang=js&"
import style0 from "./TrapList.vue?vue&type=style&index=0&id=48d42c82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d42c82",
  null
  
)

export default component.exports